import { SegmentedControl } from '@customerio/pluma-components/react';
import type { ListSearchBy } from './use-list-picker';

type SearchByControlProps = {
  /** What the free-text mode searches on: "email address" for people, "name" for objects. */
  searchLabel: string;
  /** The conditions mode's label, which each list words differently. */
  conditionsLabel?: string;
  value: ListSearchBy;
  onChange: (next: ListSearchBy) => void;
};

/** Chooses whether a picker list is narrowed by free text or by conditions. */
export function SearchByControl({
  searchLabel,
  conditionsLabel = 'conditions',
  value,
  onChange,
}: SearchByControlProps) {
  return (
    <SegmentedControl
      size="sm"
      name="toggleFilterBy"
      label="Filter by"
      value={value}
      options={[
        { label: searchLabel, value: 'search' },
        { label: conditionsLabel, value: 'conditions' },
      ]}
      onChange={(next) => onChange(next === 'conditions' ? 'conditions' : 'search')}
    />
  );
}
